import React from "react";
import {
  Box,
  Button,
  Card,
  CardActions,
  CardContent,
  Grid,
  Typography,
  Avatar,
  List,
  ListItem,
  ListItemAvatar,
  ListItemText,
} from "@material-ui/core";
import {
  Add as AddIcon,
  Forum as ForumIcon,
  People as PeopleIcon,
  Message as MessageIcon,
  CheckCircle as CheckCircleIcon,
} from "@material-ui/icons";
import { useStyles } from "../chatStyles";

const ChatWelcomeScreen = ({ onNewChat }) => {
  const classes = useStyles();

  return (
    <Box className={classes.welcomeRoot} p={{ xs: 1.5, sm: 2, md: 3 }}>
      {/* ✅ TARJETA DE BIENVENIDA */}
      <Card className={classes.welcomeCard}>
        <CardContent>
          <div className={classes.welcomeHeader}>
            <ForumIcon className={classes.welcomeIcon} />
            <Typography variant="h4" component="h1" className={classes.welcomeTitle}>
              Chat Interno
            </Typography>
          </div>

          <Typography variant="h6" color="textSecondary" paragraph>
            Sistema de comunicación interna para equipos y colaboración
          </Typography>

          <Typography variant="body1" paragraph>
            El Chat Interno te permite comunicarte de forma privada con otros miembros de tu equipo,
            compartir información importante y coordinar proyectos de manera eficiente.
          </Typography>
        </CardContent>
      </Card>

      {/* ✅ CARACTERÍSTICAS PRINCIPALES — 1 col móvil/zoom, 2 tablet, 3 desktop */}
      <Grid container spacing={2}>
        <Grid item xs={12} sm={6} lg={4}>
          <Card className={classes.featureCard}>
            <CardContent>
              <Avatar className={classes.featureIcon}>
                <PeopleIcon />
              </Avatar>
              <Typography variant="h6" gutterBottom>
                Comunicación Privada
              </Typography>
              <Typography variant="body2" color="textSecondary">
                Chats privados solo visibles para los participantes seleccionados
              </Typography>
            </CardContent>
          </Card>
        </Grid>

        <Grid item xs={12} sm={6} lg={4}>
          <Card className={classes.featureCard}>
            <CardContent>
              <Avatar className={classes.featureIcon}>
                <MessageIcon />
              </Avatar>
              <Typography variant="h6" gutterBottom>
                Tiempo Real
              </Typography>
              <Typography variant="body2" color="textSecondary">
                Mensajes sincronizados instantáneamente entre todos los participantes
              </Typography>
            </CardContent>
          </Card>
        </Grid>

        <Grid item xs={12} sm={6} lg={4}>
          <Card className={classes.featureCard}>
            <CardContent>
              <Avatar className={classes.featureIcon}>
                <CheckCircleIcon />
              </Avatar>
              <Typography variant="h6" gutterBottom>
                Colaboración Eficiente
              </Typography>
              <Typography variant="body2" color="textSecondary">
                Ideal para coordinación de equipos, proyectos y comunicación interna
              </Typography>
            </CardContent>
          </Card>
        </Grid>
      </Grid>

      {/* ✅ PASOS PARA COMENZAR */}
      <Card style={{ marginTop: 24 }}>
        <CardContent>
          <Typography variant="h6" gutterBottom>
            ¿Cómo comenzar?
          </Typography>

          <List>
            <ListItem>
              <ListItemAvatar>
                <Avatar style={{ backgroundColor: '#4CAF50' }}>1</Avatar>
              </ListItemAvatar>
              <ListItemText
                primary="Haz clic en 'Nueva Conversación'"
                secondary="Crea tu primera conversación interna"
              />
            </ListItem>

            <ListItem>
              <ListItemAvatar>
                <Avatar style={{ backgroundColor: '#2196F3' }}>2</Avatar>
              </ListItemAvatar>
              <ListItemText
                primary="Selecciona los participantes"
                secondary="Elige los usuarios que participarán en la conversación"
              />
            </ListItem>

            <ListItem>
              <ListItemAvatar>
                <Avatar style={{ backgroundColor: '#FF9800' }}>3</Avatar>
              </ListItemAvatar>
              <ListItemText
                primary="¡Comienza a chatear!"
                secondary="Envía mensajes y mantén a tu equipo comunicado"
              />
            </ListItem>
          </List>
        </CardContent>

        <CardActions className={classes.welcomeCardActions}>
          <Button
            onClick={onNewChat}
            color="primary"
            variant="contained"
            size="large"
            startIcon={<AddIcon />}
            className={classes.welcomePrimaryButton}
          >
            Crear Primera Conversación
          </Button>
        </CardActions>
      </Card>
    </Box>
  );
};

export default ChatWelcomeScreen;
